"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function FacebookSquare24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "facebook-square-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M20.0092049,2 C21.1017876,2 22,2.89130934 22,3.99079514 L22,3.99079514 L22,20.0092049 C22,21.1017876 21.1086907,22 20.0092049,22 L20.0092049,22 L15,22 L15,15 L18,15 L18,12 L15,12 L15,10 C15,9.2868013 15,9 16,9 L18,9 L18,6 L16,6 C13.0555602,6 12,6.98068997 12,10 L12,12 L9,12 L9,15 L12,15 L12,22 L3.99079514,22 C2.89821238,22 2,21.1086907 2,20.0092049 L2,20.0092049 L2,3.99079514 C2,2.89821238 2.89130934,2 3.99079514,2 L3.99079514,2 Z", id: "Combined-Shape", fill: "#000000" })));
}
function FacebookSquare24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(FacebookSquare24Svg, Object.assign({}, svgProps)));
}
exports.default = FacebookSquare24;
//# sourceMappingURL=FacebookSquare24.js.map